module.exports = __webpack_public_path__ + "img/7.52a0f845.png";